'use client'
import useGlobalStore from '@/stores/global'
import { GlobalCoin } from '@/types/coin'

export default function useDisplayCoins(data: Array<{ name: string }> | undefined, limit?: number) {
  const allCoinsSlugMap = useGlobalStore(state => state.allCoinsSlugMap)
  const existingCoins = data?.reduce((acc: GlobalCoin[], coin) => {
    const slug = coin.name?.toLowerCase?.()
    if (!slug) return acc
    const coinInfo = allCoinsSlugMap[slug]
    if (coinInfo) acc.push(coinInfo)
    return acc
  }, [])

  return limit !== undefined ? existingCoins?.slice(0, limit) : existingCoins
}
